"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeToBase64 = void 0;
const win_1 = require("./win");
const encodeToBase64 = (payloadStr) => {
    if (typeof win_1.win !== 'undefined' && win_1.win.btoa) {
        return win_1.win.btoa(payloadStr);
    }
    // NodeJS env
    if (typeof Buffer !== 'undefined' && Buffer.from) {
        return Buffer.from(payloadStr, 'utf-8').toString('base64');
    }
    throw new Error(`Failed to encode responseToken to base64. Either window.btoa (browser/jsdom) or Buffer.from (NodeJS) should be available`);
};
exports.encodeToBase64 = encodeToBase64;
//# sourceMappingURL=encodeToBase64.js.map